/* eslint-disable react/prop-types */
import { useMemo } from 'react';
import { Container } from 'theme-ui';
import { useArticle } from '@backpackjs/storefront';

import { Header } from './Header';
import { Content } from './Content';

export function ArticleTemplate({ renderSections }) {
  const article = useArticle();
  const { title, image, author, body, bodyHtml, _createdAt, createdAt } = {
    ...article,
  };

  const date = useMemo(() => {
    const [, month, day, year] = new Date(Date.parse(_createdAt || createdAt))
      .toString()
      .split(' ');
    return `${month} ${day}, ${year}`;
  }, [_createdAt, createdAt]);

  const jpg = useMemo(
    () => bodyHtml?.slice(bodyHtml.indexOf('cdn'), bodyHtml.indexOf('.jpg')),
    [bodyHtml]
  );
  const png = useMemo(
    () => bodyHtml?.slice(bodyHtml.indexOf('cdn'), bodyHtml.indexOf('.png')),
    [bodyHtml]
  );

  const srcUrl = jpg?.length < 200 ? jpg : png;
  const extension = jpg?.length < 200 ? '.jpg' : '.png';

  const fallbackContentImage =
    image ||
    (jpg || png
      ? `https://${srcUrl}${extension}`
      : 'https://cdn.shopify.com/s/files/1/1114/2308/files/brumate-blog-placeholder.jpg');

  return (
    <Container
      data-comp="ArticleTemplate"
      variant="layout.content"
      sx={{
        maxWidth: [1024, 1280],
        margin: '0 auto',
        py: [14, 18],
      }}
    >
      <Header
        title={title || article?.seo?.title}
        author={author}
        date={date}
        image={bodyHtml ? image || fallbackContentImage : null}
      />

      {renderSections()}

      <Content body={body} bodyHtml={bodyHtml} />
    </Container>
  );
}
